<template>
    <!--
    Este
    -->
    <div v-if="localOperarios.operario">
        <div
        class="card postition-relative"
        v-for="operario in Object.entries(localOperarios.operario)"
        :key="operario[0]"
        v-show="operario[1] && (operario[1].trabajos?.[0]?.datos?.nombre_operario || operario[1].operario.trabajos?.[0]?.datos?.nombre_operario)"
        >            
            <div
                class="card-header bg-gray" style="display: flex; justify-content: space-between;"
                v-if="operario[1] && (operario[1].trabajos?.[0]?.datos?.nombre_operario || operario[1].operario.trabajos?.[0]?.datos?.nombre_operario) "
            >
                <div style="display: flex; align-items: center; gap: 5px">
                    <span>
                        <div class="marcado-check">
                            <input type="checkbox" v-model="operario[1].marcado"
                                :true-value="1" :false-value="0" @change="marcarOperario(operario[1])"
                                @input="autosave = false" title="Marcar trabajo">
                        </div>
                    </span>
                    <h3
                        @click="mostrarNotas(operario[1], operario[0])"
                        :title="operario[1].trabajos?.[0]?.datos?.nombre_operario" 
                        class="card-title"
                        v-if="operario[1].trabajos"
                    >
                        <span v-if="operario[1].trabajos">Op.
                        {{ operario[1].trabajos?.[0]?.datos?.nombre_operario.slice(0, 20) }}</span>
                        
                    </h3>
                    <h3 @click="mostrarNotas(operario[1], operario[0])" style="cursor: pointer;"
                        :title="operario[1].operario.trabajos[0].datos.nombre_operario" class="card-title"
                        v-else-if="operario[1].operario">
                        Op. {{operario[1].operario.trabajos?.[0]?.datos?.nombre_operario }}
                    </h3>
                </div>
                <div class="card-tools" v-if="operario[1].totales">
                    <button type="button" class="btn btn-tool" title="Subsanar todos operario" style="color:white;"
                        @click="subsanarTrabajos(operario[1])"><i class="fas fa-tools"></i>&nbsp;Subsanar</button>
                    <button type="button" class="btn btn-tool" title="Revisar todos operario" style="color:white;"
                        @click="revisarTrabajos(operario[1])"><i class="fas fa-check-double"></i>&nbsp;Revisar</button>
                    <button type="button" class="btn btn-tool" title="Marcar facturar operario" style="color:white;"
                        @click="facturarTrabajos(operario[1])"><i class="fas fa-file-invoice-dollar"></i>
                        &nbsp; {{no_factura == 1 ? 'Marcar registrar' : 'Marcar facturar'}}</button>
                    <button type="button" class="btn btn-tool" title="Eliminar todos los trabajos del operario"
                        style="color:white;" @click="eliminarTrabajos(operario[1])"><i
                            class="fas fa-times"></i>&nbsp;Eliminar</button>
                    <button type="button" class="btn btn-tool"
                        title="Eliminar todos los trabajos del operario al cliente" style="color:white;"
                        @click="eliminarTrabajosCliente(operario[1])"><i class="far fa-times-circle"></i>&nbsp;Eliminar
                        cliente</button>
                    <button type="button" class="btn btn-tool"
                        title="Eliminar todos los trabajos del operario al operario" style="color:white;"
                        @click="eliminarTrabajosOperario(operario[1])"><i class="fas fa-times-circle"></i>&nbsp;Eliminar
                        operario</button>
                    &nbsp;
                    &nbsp;
                    <span :title="$t('general.total') + ' ' + $t('general.a cliente')" class="badge bg-success mr-2">{{
                        operario[1].totales.cliente}}&euro;</span>
                    <span :title="$t('general.total') + ' ' + $t('general.a operario')" class="badge bg-danger mr-2">
                        {{ formattedOperarioTotal(operario[1].totales.operario.base,
                        Math.round(operario[1].totales.operario.base-operario[1].totales.operario.contado)) }}</span>
                    <span :title="$t('general.rentabilidad')"
                        class="badge bg-info  mr-2">{{operario[1].totales.beneficio.porcentaje}}%</span>
                    &nbsp;
                    <button type="button" class="btn btn-tool" style="color:white"
                        @click="toggleImportarPlantilla(getKeyByValue(localOperarios.operario,operario[1]))"
                        title="Importar plantilla">
                        <i class="fas fa-plus-square mr-1"></i> Importar plantilla
                    </button>
                    <button type="button" class="btn btn-tool" style="color:white"
                        @click="toggleImportarPresupuesto(getKeyByValue(localOperarios.operario,operario[1]))"
                        title="Importar trabajo presupuesto">
                        <i class="fas fa-plus-square mr-1"></i> Importar
                    </button>
                    <button style="color: white;/*! size: ; */font-size: larger;"
                        @click="mostrarNotas(operario[1], operario[0])" title="Mostrar notas" type="button"
                        class="btn btn-tool">
                        <i class="far fa-sticky-note"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="maximize">
                        <i class="fas fa-expand"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body" v-if="operario && operario[1] && ((operario[1].trabajos && operario[1].trabajos[0].datos.nombre_operario) || (operario[1].operario.trabajos && operario[1].operario.trabajos[0].datos.nombre_operario))">
                <div v-if="operario[1].mostrarNotas">
                    <div v-if="operario[1].notas.length==0">
                        <label for="">No hay notas para este operario.</label>
                    </div>
                    <div v-if="operario[1].notas.length>0">
                        <div v-for="nota in operario[1].notas" :key="nota.id_nota" class="direct-chat-msg">
                            <div class="direct-chat-infos clearfix">
                                <!--<span class="direct-chat-name float-left">{{ mensaje.usuario_mensaje }}</span>-->
                                <span class="direct-chat-timestamp float-right">{{ nota.fecha }}</span>
                            </div>
                            <img class="direct-chat-img" src="https://plataforma.apuyen.app/img/trabajadora.jpg"
                                alt="message user image">
                            <div class="direct-chat-text" style="display: grid;">
                                <div style="display: grid; grid-template-columns: 1fr 100px 1fr; gap: 10px;">
                                    <p v-html="nota.tipo_cliente + '<br>' + nota.texto"></p>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" @change="cambiarEstadoNota(nota.id_nota, nota.revisado)"
                                            :id="'op_' + nota.id_nota" v-model="nota.revisado" class="custom-control-input">
                                        <label class="custom-control-label" :for="'op_' + nota.id_nota">Revisada</label>
                                    </div>
                                    <div v-if="nota.archivos?.length >0" style="padding: 11px;">
                                        <div class="card card-default">
                                            <div class="card-header ch">
                                                <h4 class="card-title">{{$t('general.archivos')}}</h4>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 15px;">
                                                <div class="row" style="justify-content: space-around;row-gap: 10px;">
                                                    <Galleria v-model:activeIndex="nota.activeIndex"
                                                        v-model:visible="nota.displayCustom"
                                                        :responsiveOptions="responsiveOptions" :value="nota.archivos"
                                                        :numVisible="7" containerStyle="max-width: 850px"
                                                        :circular="true" :fullScreen="true" :showItemNavigators="true"
                                                        :showThumbnails="false">
                                                        <template #item="slotProps">
                                                            <img v-if="urlglobal != 'null.pwgs.app'" class="imgcarr"
                                                                :src='slotProps.item.url_completa_descarga' preview
                                                                :alt="slotProps.item.descripcion" />
                                                            <img v-if="urlglobal == 'null.pwgs.app'" class="imgcarr"
                                                                :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + slotProps.item.documento + "&servicio=" +id'
                                                                preview :alt="slotProps.item.descripcion" />
                                                        </template>
                                                        <template #thumbnail="slotProps">
                                                            <img v-if="urlglobal != 'null.pwgs.app'" class="imgcarr"
                                                                :src='slotProps.item.url_completa_descarga' preview
                                                                :alt="slotProps.item.descripcion" />
                                                            <img v-if="urlglobal == 'null.pwgs.app'" class="imgcarr"
                                                                :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + slotProps.item.documento + "&servicio=" +id'
                                                                preview :alt="slotProps.item.descripcion" />
                                                        </template>
                                                    </Galleria>
                                                    <div v-for="(archivos, index) in nota.archivos" :key="archivos">
                                                        <a download :id="archivos.id_documento"
                                                            :href='archivos.url_completa_descarga'><i
                                                                class="fas fa-download"></i></a>
                                                        <i title="Mostrar descripción"
                                                            @click="descripcionarchivo = archivos.descripcion; toggle($event)"
                                                            style="margin-left: 20%;font-size: 1.2rem;color: #007bff;cursor: pointer;"
                                                            class="fas fa-info-circle"></i>
                                                        <div style="display: grid" v-if="archivos.image==''">
                                                            <i class="fas fa-file fa-8x"></i>
                                                        </div>
                                                        <div v-else-if="archivos.propiedad_cliente!=0">
                                                            <div class="image-container">
                                                                <img style="width: 100px; height: 127px;"
                                                                    @click="imageClick(nota, index)"
                                                                    v-if="urlglobal != 'null.pwgs.app'"
                                                                    :src='archivos.url_completa_descarga' width="100"
                                                                    preview :alt="archivos.descripcion" />
                                                                <img style="width: 100px; height: 127px;"
                                                                    @click="imageClick(nota, index)"
                                                                    v-if="urlglobal == 'null.pwgs.app'"
                                                                    :src='archivos.url_completa_descarga' width="100"
                                                                    preview :alt="archivos.descripcion" />
                                                                
                                                                <div v-if="archivos.cuando">
                                                                    <span style="width: 100px;" v-if="archivos.cuando=='despues'"
                                                                        class="badge bg-danger bg-blue">después</span>
                                                                    <span style="width: 100px;" v-else class="badge bg-danger bg-blue">{{
                                                                        archivos.cuando }}</span>
                                                                </div>
                                                                <!--  <div style="width: 350px;" class="image-zoom-overlay">
                                                                    <img style="width: 300px; height: 300px;"
                                                                        @click="imageClick(nota, index)"
                                                                        v-if="urlglobal != 'null.pwgs.app'"
                                                                        :src='archivos.url_completa_descarga'
                                                                        :alt="archivos.descripcion" />
                                                                    <img style="width: 300px; height: 300px;"
                                                                        @click="imageClick(nota, index)"
                                                                        v-if="urlglobal == 'null.pwgs.app'"
                                                                        :src='archivos.url_completa_descarga'
                                                                        :alt="archivos.descripcion" />
                                                                </div>-->
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="image-container">
                                                                <img style="width: 100px; height: 127px;"
                                                                    @click="imageClick(nota, index)"
                                                                    v-if="urlglobal != 'null.pwgs.app'"
                                                                    :src='archivos.url_completa_descarga' width="100"
                                                                    preview :alt="archivos.descripcion" />
                                                                <img style="width: 100px; height: 127px;"
                                                                    @click="imageClick(nota, index)"
                                                                    v-if="urlglobal == 'null.pwgs.app'"
                                                                    :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id'
                                                                    width="100" preview :alt="archivos.descripcion" />
                                                                
                                                                <div v-if="archivos.cuando">
                                                                    <span style="width: 100px;" v-if="archivos.cuando=='despues'"
                                                                        class="badge bg-danger bg-blue">después</span>
                                                                    <span style="width: 100px;" v-else class="badge bg-danger bg-blue">{{
                                                                        archivos.cuando }}</span>
                                                                </div>
                                                                <!--   <div style="width: 350px;" class="image-zoom-overlay">
                                                                    <img style="width: 300px; height: 300px;"
                                                                        @click="imageClick(nota, index)"
                                                                        v-if="urlglobal != 'null.pwgs.app'"
                                                                        :src='archivos.url_completa_descarga'
                                                                        :alt="archivos.descripcion" />
                                                                    <img style="width: 300px; height: 300px;"
                                                                        @click="imageClick(nota, index)"
                                                                        v-if="urlglobal == 'null.pwgs.app'"
                                                                        :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id'
                                                                        :alt="archivos.descripcion" />
                                                                </div>-->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="nota.alarmas">
                                    <div v-for="alarma in nota.alarmas" :key="alarma">
                                        <p>{{ $t('general.alarma') }}:</p>
                                        <p>{{ $t('general.usuario') }}:{{ nombre_usuario_alarma }} {{
                                            $t('general.remitente2') }}:{{ nombre_remitente_alarma }}</p>
                                        <p>{{ alarma.fecha_alarma }}{{ hora_alarma }}</p>
                                    </div>
                                    <button class="btn btn-default">{{$t('general.editaralarma')}}</button>
                                </div>
                                <!--<input type="checkbox" class="checknotas" v-model="nota.revisado"
                                    @click="cambiarEstadoNota(nota.id_nota, nota.revisado)" />-->
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showComponent && servicio.estado == 'Activo'">
                    <trabajosrealizadonuevo :id="id" :cambio="cambio"
                        :operario="getKeyByValue(localOperarios.operario,operario[1])" :servicio="servicio" />
                </div>
                <div v-if="mostrarImportarPresupuesto[getKeyByValue(localOperarios.operario,operario[1])]">
                    <TrabajosImportarPresupuesto :id="id" :operario="getKeyByValue(localOperarios.operario,operario[1])"
                        :servicio="servicio"
                        @trabajos-importados="ocultarImportarPresupuesto(getKeyByValue(localOperarios.operario,operario[1]))" />
                </div>
                <div v-if="mostrarImportarPlantilla[getKeyByValue(localOperarios.operario,operario[1])]">
                    <TrabajosImportarPlantilla :id="id" :operario="getKeyByValue(localOperarios.operario,operario[1])"
                        :servicio="servicio"
                        @plantillas-importadas="ocultarImportarPlantilla(getKeyByValue(localOperarios.operario,operario[1]))" />
                </div>
                <div v-show="!ocultarcliente">
                    <trabajosrealizadoconcepto @cambiorevisado="cambioRevisado" ref="conc1" @cambio="cambiado" v-for="totales in operario[1].trabajos" @trabajomarcado="trabajoMarcado"
                        :key="totales" :totales="totales" :id="id" :servicio="servicio"/>
                </div>
                <!--
                <div v-if="operario[1].Cliente" v-show="!ocultarcliente">
                    <trabajosrealizadoconcepto ref="conc1" @cambio="cambiado"
                        v-for="totales in operario[1].Cliente.trabajos" :key="totales" :totales="totales" :id="id"
                        :servicio="servicio" />
                </div>
                <div v-if="operario[1].Compañia" v-show="!ocultarcliente">
                    <trabajosrealizadoconcepto ref="conc2" @cambio="cambiado"
                        v-for="totales in operario[1].Compañia.trabajos" :key="totales" :totales="totales" :id="id"
                        :servicio="servicio" />
                </div>-->
                <!-- Renderizado de Perjudicados --><!--
                <div v-for="(perjudicado, index) in getPerjudicados(operario[1])" :key="index" v-show="!ocultarcliente">
                    <trabajosrealizadoconcepto ref="conc3" @cambio="cambiado" v-for="totales in perjudicado.trabajos"
                        :key="totales" :totales="totales" :id="id" :servicio="servicio" />
                </div>

                <div v-if="operario[1]._" v-show="!ocultarcliente">
                    <div v-for="totales in operario[1]._.trabajos" :key="totales.id" class="position-relative">
                        <trabajosrealizadoconcepto ref="conc4" @cambio="cambiado" :totales="totales" :id="id"
                            :servicio="servicio" />
                    </div>
                </div>
                -->
                <!-- <hr v-if="operario[1].operario" v-show="!ocultaroperario" style="border:2px dashed gray"> -->

                <div v-if="operario[1].operario" v-show="!ocultaroperario">
                    <trabajosrealizadoconceptoOperario @cambiorevisado="cambioRevisado" ref="conc5" @cambio="cambiado" @trabajomarcado="trabajoMarcado"
                        :tipooperario="operario[1].operario.trabajos[0].datos.tipo_operario"
                        v-for="totales in operario[1].operario.trabajos" :key="totales" :totales="totales" :id="id"
                        :servicio="servicio" />
                </div><!--PROGRESSBAR-->
                <div v-if="detalletrabajos[operario[0]]">
                    <div v-for="tiempos_visita in detalletrabajos[operario[0]].visitas" :key="tiempos_visita" class="progress-group" style="margin-bottom: 4px;">
                        <span class="progress-text" style="font-size: 10px;"
                            :title="tiempos_visita.anterior.codigo.title"><b>{{
                            tiempos_visita.anterior.codigo.valor }}</b>&nbsp;</span>
                        <span class="progress-number" style="font-size: 10px; float: right"
                            :title="tiempos_visita.actual.codigo.title"><b>{{
                                tiempos_visita.actual.codigo.valor }}</b></span>
                        <div class="progress">
                            <div :class="'progress-bar  progress-bar-striped ' + tiempos_visita.color"
                                :title="'Tiempo teórico desplazamiento ' + tiempos_visita.anterior.teorico.hora + 'h ' + tiempos_visita.anterior.teorico.minuto + ' min'" role="progressbar"
                                :style="'min-width: 32%; display: block !important; width:' + (100-Math.round(tiempos_visita.porcentaje_visita))+'%'"
                                aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"
                                @click="anadirTrabajoTiempos(operario[0],'Desplazamiento',tiempos_visita)">
                                <span :title="tiempos_visita.anterior.hora_finaliza.title"
                                    style="float:left; font-size: 10px; margin:3px; color: #ffffff; font-weight: bold;">
                                    {{ tiempos_visita.anterior.hora_finaliza.valor}}</span>
                                <b v-if="tiempos_visita.anterior.km" style="position:absolute;margin-top:7px"
                                    :title="tiempos_visita.anterior.duracion.title">{{
                                    tiempos_visita.anterior.duracion.horas }}:{{
                                    tiempos_visita.anterior.duracion.minutos }}
                                    ({{ tiempos_visita.anterior.km }}km)</b>
                            </div>
                            <div class="progress-bar" role="progressbar"
                                :title="tiempos_visita.actual.duracion.title"
                                :style="'background-color: #b5b3b3; min-width: 28%; display: block !important; width:' + Math.round(tiempos_visita.porcentaje_visita) +'%'"
                                :aria-valuenow="30"
                                aria-valuemin="0" aria-valuemax="100"
                                @click="anadirTrabajoTiempos(operario[0],'Trabajos Realizados',tiempos_visita)">
                                <span :title="tiempos_visita.actual.hora.title"
                                    style="float:left; font-size: 10px; margin:3px; color: #ffffff; font-weight: bold;">
                                    {{ tiempos_visita.actual.hora.valor}}</span>
                                <b style="position:absolute;margin-top:7px">{{
                                    tiempos_visita.actual.duracion.horas }}:{{
                                    tiempos_visita.actual.duracion.minutos}}</b>
                                <span :title="tiempos_visita.actual.hora_finaliza.title"
                                    style="float:right; font-size: 10px; margin:3px; color: #ffffff; font-weight: bold;">
                                    {{ tiempos_visita.actual.hora_finaliza.valor}}</span>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
            <div v-if="operario && operario[1].trabajos && operario[1].trabajos[0].datos.nombre_operario">
                <trabajosrealizadosoperariofooter ref="foot" :datos="operario[1]" :actualizar="actualizartot" />
            </div>
        </div>
        <OverlayPanel ref="opdescripcion">
            <div class="flex flex-column gap-3 w-25rem">
                <b>Descripción del archivo</b>
                <p v-html="descripcionarchivo"></p>
            </div>
        </OverlayPanel>
    </div>
</template>
<script>
import Galleria from 'primevue/galleria';
import { PwgsApi } from '../../../../services/PwgsApi';
import trabajosrealizadosoperariofooter from './TrabajosRealizadosOperarioFooter.vue';
import trabajosrealizadoconcepto from './TrabajoRealizadoConcepto.vue';
import trabajosrealizadoconceptoOperario from './TrabajoRealizadoConceptoOperario.vue';
import trabajosrealizadonuevo from './TrabajoRealizadoNuevo.vue';
import TrabajosImportarPresupuesto from './TrabajosImportarPresupuesto.vue';
import TrabajosImportarPlantilla from './TrabajosImportarPlantilla.vue';
import OverlayPanel from 'primevue/overlaypanel';

export default ({
    props:[
        'id',
        'servicio',
        'recargar',
        'ocultarcliente',
        'ocultaroperario',
        'totalrent',
        'totaloperario',
        'totalcliente',
        'mostrarfacturar',
        'operariosingular',
        'operarios',
        'actualizartotales'
    ],
    setup() {
        return;
    },
    components: {
        trabajosrealizadosoperariofooter,
        trabajosrealizadoconcepto,
        trabajosrealizadoconceptoOperario,
        trabajosrealizadonuevo,
        TrabajosImportarPresupuesto,
        TrabajosImportarPlantilla,
        Galleria,
        OverlayPanel,
    },
    data() {
        return {
            no_factura: localStorage.getItem('no_factura'),
            cambio:false,
            actualizartot:false,
            showComponent: true,
            detalletrabajos:[],
            mostrarImportarPresupuesto: {},
            mostrarImportarPlantilla: {}, 
            //operarios: [],
            totalescliente: '',
            totalesoperario: '',
            totalesrentabilidad: '',
            suma: [],
            cargar: false,
            localOperarios: {},
            urlglobal: '',
            trabajossub: false,
            trabajosrev: false,
            trabajosfac:false,
            descripcionarchivo:'',
            responsiveOptions: [
                {
                    breakpoint: '1024px',
                    numVisible: 5
                },
                {
                    breakpoint: '768px',
                    numVisible: 3
                },
                {
                    breakpoint: '560px',
                    numVisible: 1
                }
            ],
        };
    },
    methods: {
        trabajoMarcado(idtrabajo, marcado){
            this.$emit('trabajomarcado', idtrabajo, marcado);  
        },
        marcarOperario(operario, marcadotodos) {
            this.$emit('marcaoperario', operario, operario.marcado);
            if(this.$refs.conc1){
                for(let ref of this.$refs.conc1){
                    ref.marcarOperario(operario, marcadotodos);
                }
            }
            if(this.$refs.conc5){
                for(let ref of this.$refs.conc5){
                    ref.marcarOperario(operario, marcadotodos);
                }
            }
        },
        toggle(event){
            this.$refs.opdescripcion.toggle(event);
        },
        cambiarMarcadoTrue(){
            if(this.$refs.conc1){
                for(let ref of this.$refs.conc1){
                    ref.cambiarMarcadoTrue();
                }
            }
            if(this.$refs.conc2){
                for(let ref of this.$refs.conc2){
                    ref.cambiarMarcadoTrue();
                }
            }
            if(this.$refs.conc3){
                for(let ref of this.$refs.conc3){
                    ref.cambiarMarcadoTrue();
                }
            }
            if(this.$refs.conc4){
                for(let ref of this.$refs.conc4){
                    ref.cambiarMarcadoTrue();
                }
            }
            if(this.$refs.conc5){
                for(let ref of this.$refs.conc5){
                    ref.cambiarMarcadoTrue();
                }
            }
        },
        cambiarMarcadoFalse(){
            if(this.$refs.conc1){
                for(let ref of this.$refs.conc1){
                    ref.cambiarMarcadoFalse();
                }
            }
            if(this.$refs.conc2){
                for(let ref of this.$refs.conc2){
                    ref.cambiarMarcadoFalse();
                }
            }
            if(this.$refs.conc3){
                for(let ref of this.$refs.conc3){
                    ref.cambiarMarcadoFalse();
                }
            }
            if(this.$refs.conc4){
                for(let ref of this.$refs.conc4){
                    ref.cambiarMarcadoFalse();
                }
            }
            if(this.$refs.conc5){
                for(let ref of this.$refs.conc5){
                    ref.cambiarMarcadoFalse();
                }
            }
        },
        cambiado(val){
            this.cambio=val;
        },
  
        actualiztotales(id, resultados, baremo, idtrabajo, eliminar, tipo, confirma){
            try{
                console.log("newvalprovsoper333", id, resultados, this.localOperarios, eliminar);
                var indice = Object.keys(resultados.operario).indexOf(id);
                this.$refs.foot[indice].actualizatotales(id, resultados);
                console.log('llegaaccli', tipo, baremo);
                if(baremo || confirma){
                    var index = -1;
                    if(tipo == 'cliente'){
                        console.log('llegaaccli');
                        for(let trabajo of Object.entries(resultados.operario[id].trabajos)){
                            if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                index = trabajo[0];
                            }
                        }
                        if(index != -1){
                            this.localOperarios.operario[id].trabajos[index] = resultados.operario[id].trabajos[index];
                        }
                    }else{
                        for(let trabajo of Object.entries(resultados.operario[id].operario.trabajos)){
                            console.log('llegaaccli2', trabajo);
                            if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                console.log('llegaaccli3', trabajo);
                                index = trabajo[0];
                            }
                        }
                        console.log('llegaaccli4', index, this.localOperarios);
                        if(index != -1){
                            this.localOperarios.operario[id].operario.trabajos[index] = resultados.operario[id].operario.trabajos[index];
                        }
                        console.log('llegaaccli5', index, this.localOperarios);
                    }
                    if(this.localOperarios.operario[id].operario == undefined && resultados.operario[id].operario != undefined && resultados.operario[id].operario.trabajos.length > 0){
                        this.localOperarios.operario[id].operario = resultados.operario[id].operario;
                    }else if(this.localOperarios.operario[id].operario.trabajos.length != resultados.operario[id].operario.trabajos.length){
                        this.localOperarios.operario[id].operario.trabajos.push(resultados.operario[id].operario.trabajos[resultados.operario[id].operario.trabajos.length - 1]);
                    }
                    if(this.localOperarios.operario[id].trabajos == undefined && resultados.operario[id].trabajos != undefined && resultados.operario[id].trabajos.length > 0){
                        this.localOperarios.operario[id].trabajos = resultados.operario[id].trabajos;
                    }else if(this.localOperarios.operario[id].trabajos.length != resultados.operario[id].trabajos.length){
                        this.localOperarios.operario[id].trabajos.push(resultados.operario[id].trabajos[resultados.operario[id].trabajos.length - 1]);
                    }
                }
                if(eliminar){
                    var index2 = -1;
                    if(tipo == 'cliente'){
                        if(this.localOperarios.operario[id].trabajos.length == 1){
                            delete this.localOperarios.operario[id].trabajos;
                        }else{
                            for(let trabajo of Object.entries(this.localOperarios.operario[id].trabajos)){
                                if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                    index2 = trabajo[0];
                                }
                            }
                            if(index2!=-1){
                                this.localOperarios.operario[id].trabajos.splice(index2, 1);
                            }                  
                        }
                    }else{
                        if(this.localOperarios.operario[id].operario.trabajos.length == 1){
                            delete this.localOperarios.operario[id].operario;
                        }else{
                            for(let trabajo of Object.entries(this.localOperarios.operario[id].operario.trabajos)){
                                if(trabajo[1].datos.idtrabajo_servicio == idtrabajo){
                                    index2 = trabajo[0];
                                }
                            }
                            if(index2!=-1){
                                this.localOperarios.operario[id].operario.trabajos.splice(index2, 1);
                            }
                        }
                    }
                }
                this.localOperarios.operario[id].totales = resultados.operario[id].totales;
            }catch(e){
                console.log();
            }
        },
        imageClick(nota, index) {
            nota.activeIndex = index;
            nota.displayCustom = true;
        },
        toggleComponent() {
            this.showComponent = !this.showComponent;
        },
        vaciarOperarios(){            
            this.localOperarios = {};
        },
        async subsanarTodosMarcados(ids, fecha){
            console.log('llega', ids);
            ids.forEach(trabajo => {
                setTimeout(() => {                                
                    if(this.$refs.conc1){
                        for(let ref of this.$refs.conc1){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }
                    if(this.$refs.conc5){
                        for(let ref of this.$refs.conc5){
                            ref.guardarsubsanado(trabajo, false);
                            ref.cambiarFecha(trabajo, fecha);
                        }
                    }                                
                }, 1000);
            })                                  
            this.cargardatos;
        },
        async subsanarTodos(){
            for(let operario of Object.values(this.localOperarios.operario)){
                const api = new PwgsApi();
                var trabajos = [];
                for(let datos of Object.entries(operario)){
                    if(datos[0] !='totales'){
                        if(datos[1].trabajos){
                            for (let i = 0; i < datos[1].trabajos.length; i++){
                                if(datos[1].trabajos[i].datos.marcado)
                                trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                            }
                        }
                    }
                }
                var bien = false;
                var errores = '';
                if(trabajos.length > 0){
                    for(let trabajo of trabajos){
                        try{
                            await api.put('trabajos/' + this.$props.id + '/subsanar', {ids_trabajos:[trabajo]});
                            bien = true;                                                   
                            setTimeout(() => {                                
                                if(this.$refs.conc1){
                                    for(let ref of this.$refs.conc1){
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if(this.$refs.conc2){
                                    for(let ref of this.$refs.conc2){
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if(this.$refs.conc3){
                                    for(let ref of this.$refs.conc3){
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if(this.$refs.conc4){
                                    for(let ref of this.$refs.conc4){
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }
                                if(this.$refs.conc5){
                                    for(let ref of this.$refs.conc5){
                                        ref.guardarsubsanado(trabajo, false);
                                    }
                                }                                
                            }, 1000);
                        }
                        catch (error) {                            
                                if (error == "Error: Token no válido") {
                                    api.get('logout');
                                    localStorage.removeItem('token');
                                    this.$router.push('/login');
                                }
                                errores = error;
                        }
                    }
                }
                if(bien){
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para subsanar', life: 2000 });  
                }else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                }
                this.cargardatos;
            }
        },
        async subsanarTrabajos(operario) {
            const api = new PwgsApi();
            var trabajos = [];
            for (let i = 0; i < operario.trabajos.length; i++){                        
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            if(operario.operario){
                for (let i = 0; i < operario.operario.trabajos.length; i++){
                    trabajos.push(operario.operario.trabajos[i].datos.idtrabajo_servicio);
                }
            }
            if(trabajos.length > 0){                
                    if(window.confirm('¿Quiere subsanar todos los trabajos del operario?')){
                        var bien = false;
                        var errores = '';
                        for(let trabajo of trabajos){
                            try{
                                await api.put('trabajos/' + this.$props.id + '/subsanar', {ids_trabajos:[trabajo]});
                                bien = true;
                                this.cargardatos;
                                setTimeout(() => {                                    
                                    if(this.$refs.conc1){
                                        for(let ref of this.$refs.conc1){
                                            ref.guardarsubsanado(trabajo, false);
                                        }
                                    }
                                    if(this.$refs.conc2){
                                        for(let ref of this.$refs.conc2){
                                            ref.guardarsubsanado(trabajo, false);
                                        }
                                    }
                                    if(this.$refs.conc3){
                                        for(let ref of this.$refs.conc3){
                                            ref.guardarsubsanado(trabajo, false);
                                        }
                                    }
                                    if(this.$refs.conc4){
                                        for(let ref of this.$refs.conc4){
                                            ref.guardarsubsanado(trabajo, false);
                                        }
                                    }
                                    if(this.$refs.conc5){
                                        for(let ref of this.$refs.conc5){
                                            ref.guardarsubsanado(trabajo, false);
                                        }
                                    }                                    
                                }, 1000);
                            }
                            catch (error) {
                                    errores = error;
                                    if (error == "Error: Token no válido") {
                                        api.get('logout');
                                        localStorage.removeItem('token');
                                        this.$router.push('/login');
                                    }
                            }
                        }
                        if(bien){
                            this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para subsanar', life: 2000 });  
                        }else{
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                        }
                    }
                
            }
            
        },
        async cargarDetalle() {
            const api = new PwgsApi();
            this.detalletrabajos = await api.get('servicios/' + this.$props.id + '/tiempos-operarios');

            
        },      
        async facturarTrabajos(operario) {
            let trabajos = [];
            for (let i = 0; i < operario.trabajos.length; i++) {
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            
            const api = new PwgsApi();
            var bien = false;
            var errores = '';
            console.log('trabajosFacturar', trabajos);
            for(let trabajo of trabajos){
                try{
                    let subidadatos = { ids_trabajos: [trabajo] };
                    await api.put('trabajos/' + this.$props.id + '/facturar-varios', subidadatos);
                    bien = true;
                    this.cargardatos;
                    console.log('vuelta');
                    console.log("\n");
                    console.log(trabajo);
                    console.log("\n");
                    if(this.$refs.conc1){
                        console.log("refconc1");
                        console.log("\n");
                        for(let ref of this.$refs.conc1){
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.guardarfacturar(trabajo, false);
                        }
                    }
                    if(this.$refs.conc5){
                        console.log("refconc5");
                        console.log("\n");
                        for(let ref of this.$refs.conc5){
                            ref.guardarfacturar(trabajo, false);
                        }
                    }         
                }
                catch (error) {
                    if (error == "Error: Token no válido") {
                        api.get('logout');
                        localStorage.removeItem('token');
                        this.$router.push('/login');
                    }
                    errores = error;
                }
            }       
            if(bien){
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para facturar', life: 2000 });
            }     
            else{
                this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
            }
        },
        cambioRevisado(trabajo, revisado){
            console.log('trabajosRevisar', this.localOperarios, trabajo, revisado);
            try{
                for(let operario of Object.entries(this.localOperarios.operario)){
                    if(operario[1].operario){
                        for(let totales of operario[1].operario.trabajos){
                            if(totales.datos.idtrabajo_servicio == trabajo){
                                console.log('encontrado');
                                totales.datos.visto_tramitador_trabajo = revisado;
                                return;
                            }
                        }
                    }
                    if(operario[1].trabajos){
                        for(let trabs of operario[1].trabajos){
                            if(trabs.datos.idtrabajo_servicio == trabajo){
                                trabs.datos.visto_tramitador_trabajo = revisado;
                                return;
                            }
                        }
                    }
                }
            }catch(e){
                console.error(e);
            }
            console.log('trabajosRevisar2', this.localOperarios, trabajo, revisado);
        },
        async revisarTrabajos(operario) {
            var todosmarcados = true;    
            let trabajos = [];        
            console.log('llega', operario);
            try{
                if(operario.operario){
                    for(let totales of operario.operario.trabajos){    
                        if(totales.datos.visto_tramitador_trabajo == ''){
                            console.log('llega1');
                            todosmarcados = false;
                        }
                    }
                }
                
                if(todosmarcados && operario.trabajos){
                    for(let trabs of operario.trabajos){
                        if(trabs.datos.visto_tramitador_trabajo == ''){
                            todosmarcados = false;
                        }
                    }
                }
            }catch(e){
                console.error(e);
            }
            console.log('llega2');
            for (let i = 0; i < operario.trabajos.length; i++) {
                trabajos.push(operario.trabajos[i].datos.idtrabajo_servicio);
            }
            if(operario.operario){
                for (let i = 0; i < operario.operario.trabajos.length; i++){
                    trabajos.push(operario.operario.trabajos[i].datos.idtrabajo_servicio);
                }
            }
            console.log('llega3');
            console.log('trabajosRevisar', trabajos);
            const api = new PwgsApi();
            var bien = false;
            var errores = '';
            if(todosmarcados){
                console.log('llega4');
                for(let trabajo of trabajos){
                    try{                        
                        bien = true;
                        this.cargardatos;
                        if(this.$refs.conc1){
                            for(let ref of this.$refs.conc1){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc2){
                            for(let ref of this.$refs.conc2){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc3){
                            for(let ref of this.$refs.conc3){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc4){
                            for(let ref of this.$refs.conc4){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }
                        if(this.$refs.conc5){
                            console.log("refconc5");
                            console.log("\n");
                            for(let ref of this.$refs.conc5){
                                ref.guardarrevisado(trabajo, false, false, true);
                            }
                        }                
                    }
                    catch (error) {
                        if (error == "Error: Token no válido") {
                            api.get('logout');
                            localStorage.removeItem('token');
                            this.$router.push('/login');
                        }
                        errores = error;
                    }            
                }
                if(bien){
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos quitados de revisar', life: 2000 });
                    if(operario.operario){
                        for(let totales of operario.trabajos){    
                            if(totales.opciones.bloqueos.visto==0 && totales.datos.trabajo_duplicado != 1){
                                totales.datos.visto_tramitador_trabajo = '';
                            }
                        }
                    }
                    
                    if(todosmarcados && operario.trabajos){
                        for(let trabs of operario.trabajos){
                            if(trabs.opciones.bloqueos.visto==0 && trabs.datos.trabajo_duplicado != 1){
                                trabs.datos.visto_tramitador_trabajo = '';
                            }
                        }
                    }
                }     
                else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                }
            }else{
                console.log('llega5');
                for(let trabajo of trabajos){
                    try{
                        bien = true;
                        this.cargardatos;
                        if(this.$refs.conc1){
                            for(let ref of this.$refs.conc1){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc2){
                            for(let ref of this.$refs.conc2){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc3){
                            for(let ref of this.$refs.conc3){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc4){
                            for(let ref of this.$refs.conc4){
                                ref.guardarrevisado(trabajo, false, true);
                            }
                        }
                        if(this.$refs.conc5){
                            console.log("refconc5");
                            console.log("\n");
                            for(let ref of this.$refs.conc5){
                                ref.guardarrevisado(trabajo, false);
                            }
                        }                
                    }
                    catch (error) {
                        if (error == "Error: Token no válido") {
                            api.get('logout');
                            localStorage.removeItem('token');
                            this.$router.push('/login');
                        }
                        errores = error;
                    }            
                }
                if(bien){
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos guardados para revisar', life: 2000 });
                    if(operario.operario){
                        for(let totales of operario.trabajos){    
                            if(totales.opciones.bloqueos.visto==0 && totales.datos.trabajo_duplicado != 1){
                                totales.datos.visto_tramitador_trabajo = 'SI';
                            }
                        }
                    }
                    
                    if(todosmarcados && operario.trabajos){
                        for(let trabs of operario.trabajos){
                            if(trabs.opciones.bloqueos.visto==0 && trabs.datos.trabajo_duplicado != 1){
                                trabs.datos.visto_tramitador_trabajo = 'SI';
                            }
                        }
                    }
                }     
                else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errores, life: 5000 });
                }
            }
        },
        toggleImportarPresupuesto(operarioId) {
            //this.mostrarImportarPresupuesto = !this.mostrarImportarPresupuesto;
            if (this.mostrarImportarPresupuesto[operarioId]) {
                this.mostrarImportarPresupuesto[operarioId] = !this.mostrarImportarPresupuesto[operarioId];
            } else {
                this.mostrarImportarPresupuesto[operarioId] = true;
            }
        },
        toggleImportarPlantilla(operarioId) {
            if (this.mostrarImportarPlantilla[operarioId]) {
                this.mostrarImportarPlantilla[operarioId] = !this.mostrarImportarPlantilla[operarioId];
            } else {
                this.mostrarImportarPlantilla[operarioId] = true;
            }
        },
        ocultarImportarPresupuesto(operarioId) {
            //this.mostrarImportarPresupuesto = false; // Ocultar el callout de importar
            this.mostrarImportarPresupuesto[operarioId] = false;
            this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: this.$t('general.datosguardadoscorrectamente'), life: 2000 });
            this.cargardatos(); // Volver a cargar los datos del componente padre
        },
        ocultarImportarPlantilla(operarioId) {
            //this.mostrarImportarPlantilla = false; // Ocultar el callout de importar
            this.mostrarImportarPlantilla[operarioId] = false;
            this.$toast.add({ severity: 'success', summary: this.$t('general.guardado'), detail: this.$t('general.datosguardadoscorrectamente'), life: 2000 });
            this.cargardatos(); // Volver a cargar los datos del componente padre
        },
        formattedOperarioTotal(base, contado) {
            if(base){
            let baseFormatted = `${base}€`;
            if (contado && contado !== 0) {
                baseFormatted += ` (A operario ${contado}€)`;
            }
            return baseFormatted;
            }
        },

        async desactivaralarma(idnota, idalarma) {
            const api = new PwgsApi();
            let subidadatos = { id_alarma: idalarma};
            await api.put('servicios/' + this.$props.id + '/notas/' + idnota, subidadatos);
            this.motivo = '';
            this.cargarnotas();
        },
        async cambiarEstadoNota(id_nota, estadoActual) {
            // Aquí puedes manejar la lógica diferente para marcar y desmarcar
            if (!estadoActual) {
                this.procesarNotaRevisada(id_nota);
            } else {
                this.procesarNotaNoRevisada(id_nota);
            }
        },

        async procesarNotaNoRevisada(idnota) {
            const api = new PwgsApi();
            let body = {tipo: "trabajos_no_revisados", ids_avisos: [idnota], estado: 1};
            await api.put('/avisos/revisar-avisos', body);
        },
        async procesarNotaRevisada(idnota) {
            const api = new PwgsApi();
            let body = {tipo: "trabajos_no_revisados", ids_avisos: [idnota], estado: 0};
            await api.put('/avisos/revisar-avisos', body);
        },
        async eliminarTrabajos(operario){
            let trabajos = [];
            console.log('operario', operario);
            for(let datos of Object.entries(operario)){
                if(datos[0] !='totales'){
                    if(datos[0] == 'trabajos'){
                        for (let i = 0; i < datos[1].length; i++){
                            trabajos.push(datos[1][i].datos.idtrabajo_servicio);
                        }
                    }else{
                        for (let i = 0; i < datos[1].trabajos.length; i++){
                            trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                        }
                    }
                }
            }
            if(window.confirm('¿Quiere eliminar todos los trabajos del operario?')){
                for(let trabajo of trabajos){
                    if(this.$refs.conc1){
                        for(let ref of this.$refs.conc1){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc5){
                        for(let ref of this.$refs.conc5){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }  
            }                      
        },
        async eliminarTrabajosCliente(operario){
            let trabajos = [];
            for(let datos of Object.entries(operario)){
                if(datos[0] != 'operario' && datos[0] !='totales'){
                    if(datos[0] == 'trabajos'){
                        for (let i = 0; i < datos[1].length; i++){
                            trabajos.push(datos[1][i].datos.idtrabajo_servicio);
                        }
                    }else{
                        for (let i = 0; i < datos[1].trabajos.length; i++){
                            trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                        }
                    }
                }
            }
            if(window.confirm('¿Quiere eliminar todos los trabajos a clientes del operario?')){
                for(let trabajo of trabajos){
                    if(this.$refs.conc1){
                        for(let ref of this.$refs.conc1){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc5){
                        for(let ref of this.$refs.conc5){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }  
            }                 
        },
        async eliminarTrabajosOperario(operario){
            let trabajos = [];
            for(let datos of Object.entries(operario)){
                if(datos[0] == 'operario'){
                    for (let i = 0; i < datos[1].trabajos.length; i++){
                        trabajos.push(datos[1].trabajos[i].datos.idtrabajo_servicio);
                    }
                }
            }
            if(window.confirm('¿Quiere eliminar todos los trabajos a operarios del operario?')){
                for(let trabajo of trabajos){
                    if(this.$refs.conc1){
                        for(let ref of this.$refs.conc1){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc2){
                        for(let ref of this.$refs.conc2){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc3){
                        for(let ref of this.$refs.conc3){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc4){
                        for(let ref of this.$refs.conc4){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                    if(this.$refs.conc5){
                        for(let ref of this.$refs.conc5){
                            ref.eliminartrabajosinconf(trabajo);
                        }
                    }
                }  
            }                 
        },
        async cargardatos(nuevo, operario, tipotr, cantidad) {
            //GET  modulos/pwgsapi/index.php/trabajos/:id_servicio/trabajos-servicio
            const api = new PwgsApi();
            if(nuevo){
                var opersnuevo = await api.get('trabajos/' + this.id + '/trabajos-servicio');
                console.log('entraif', opersnuevo);
                console.log('lleganuevo', operario, this.localOperarios ,opersnuevo);
                if(tipotr == 'cliente'){
                    console.log('nuevotr', cantidad);
                    for(let i = cantidad; i > 0; i--){
                        if(!this.localOperarios.operario[operario].trabajos){
                            this.localOperarios.operario[operario].trabajos = [];
                        }
                        this.localOperarios.operario[operario].trabajos.push(opersnuevo.operario[operario].trabajos[this.localOperarios.operario[operario].trabajos.length]);
                    }
                }else{
                    for(let i = cantidad; i > 0; i--){
                        if(!this.localOperarios.operario[operario].operario){
                            this.localOperarios.operario[operario].operario = {trabajos:[]};
                        }
                        this.localOperarios.operario[operario].operario.trabajos.push(opersnuevo.operario[operario].operario.trabajos[this.localOperarios.operario[operario].operario.trabajos.length]);
                    }
                }
            }else{
                this.localOperarios = await api.get('trabajos/' + this.id + '/trabajos-servicio');            
                console.log('entraelse', this.localOperarios);
            }
            console.log('entramas', this.operariosingular);
            if (this.operariosingular > 0) {
                // Filtramos los operarios si 'operariosingular' está definido y es mayor que 0
                for (let operario in this.localOperarios.operario) {
                    if (operario != this.operariosingular) {
                        delete this.localOperarios.operario[operario];       
                    }                    
                }
            }
            // Calculamos la rentabilidad total
            this.totalesrentabilidad = this.totalcliente - this.totaloperario;
            this.totalesrentabilidad = Math.round((this.totalesrentabilidad * 100).toFixed(2) / this.totalcliente) + "%";
        },
        async cargarNotas(operario, idop){
            if(!operario.notas){
                const api = new PwgsApi();
                              
                    const nts = await api.get('/servicios/'+this.id+'/notas?id_operario='+idop);
                    var notas = nts;
                    if(notas){
                        this.localOperarios.operario[idop].notas = notas.map(nota => {
                            return this.comprobarRevisado(nota);
                        });
                        for(let nota of operario.notas){
                            nota.displayCustom = false;
                            nota.activeIndex = 0;
                        }
                    }else{
                        operario.notas = [];
                    } 
                    operario.mostrarNotas = false;
               
                }
                operario.mostrarNotas = !operario.mostrarNotas;
        },

        comprobarRevisado(nota) {
            console.log('revisanota', nota);
            return {
                ...nota,
                revisado: nota.realizado_operario && nota.realizado_operario.toLowerCase() === "si"
            };
        },
        mostrarNotas(operario, id){
            
                this.cargarNotas(operario, id);            
            
        },
        getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
        },
        togglecargar() { 
            this.cargar = !this.cargar;
        },
        getPerjudicados(operario) {
            if (!operario || typeof operario !== 'object' || Object.keys(operario).length === 0) {
                return [];
            }
            return Object.keys(operario)
                .filter(key => key.startsWith('Perjudicado_'))
                .map(key => operario[key]);
        },
        async anadirTrabajoTiempos(id_operario,descripcion,tiempos_visita){
            /*console.log('anadirTrabajoTiempos',id_operario);
            console.log('anadirTrabajoTiempos',descripcion);
            console.log('anadirTrabajoTiempos',tiempos_visita);*/
            
            //POST  modulos/pwgsapi/index.php/trabajos/:id_servicio/crear-trabajo
            const api = new PwgsApi();
            var subidadatos = {};

            if(descripcion=='Desplazamiento'){
                subidadatos = {
                    destinatario: 'operario',
                    id_operario: id_operario,
                    nombre: descripcion,
                    visto: 'SI',
                    estado: 'Subsanado',
                    id_cliente: tiempos_visita.actual?.id_cliente,
                    id_especialidad: tiempos_visita.actual?.id_especialidad,
                    //id_visita: tiempos_visita.actual?.id_visita,
                    tiempo_empleado: tiempos_visita.anterior?.duracion.horas+':'+tiempos_visita.anterior?.duracion.minutos,
                };
            }else{
                subidadatos = {
                    destinatario: 'operario',
                    id_operario: id_operario,
                    nombre: descripcion,
                    visto: 'SI',
                    estado: 'Subsanado',
                    id_cliente: tiempos_visita.actual?.id_cliente,
                    id_especialidad: tiempos_visita.actual?.id_especialidad,
                    //id_visita: tiempos_visita.actual?.id_visita,
                    tiempo_empleado: tiempos_visita.actual?.duracion.horas+':'+tiempos_visita.actual?.duracion.minutos,
                };
            }
            let errores = false;
            try {
                await api.post('trabajos/' + this.$props.id + '/crear-trabajo', subidadatos);
            } catch (error) {
                console.error('Error al crear el trabajo:', error);
                this.$toast.add({ severity: 'error', summary: "Error al crear el trabajo", detail: error.message || error, life: 5000 });
                errores = true;
            }
            if (!errores) {
                // Mostrar el toast de éxito
                this.$toast.add({ severity: 'success', summary: "Trabajo agregado", detail: "El trabajo han sido agregado correctamente.", life: 5000 });
            }
            // Recargar datos o emitir un evento si es necesario
            setTimeout(()=>{
                this.cargardatos();
            },1500);
        }
    },
    mounted() {
        this.urlglobal = localStorage.getItem("direccion");
        if (this.operariosingular) {
            console.log('entramount1');
        // Si 'operariosingular' es verdadero, cargamos los datos nosotros mismos
            this.cargardatos();
        } else if (this.operarios && Object.keys(this.operarios).length > 0) {
            console.log('entramount2');
            // Si 'operarios' está disponible y 'operariosingular' es falso o indefinido, usamos los datos del padre
            this.localOperarios = JSON.parse(JSON.stringify(this.operarios));
        }
        this.cargarDetalle();
        
    },
    watch: {
        localOperarios(newVal) {
            console.log("newvallocalop", newVal);  
        },
        actualizartotales(){
            this.actualizartot = !this.actualizartot;
        },
        id() { 
            this.localOperarios = [];
            this.cargarDetalle();

            //this.cargardatos();
        },
        cargar() { 
            //this.cargardatos();
        },
        recargar() {
            //this.cargardatos();
        },
        operarios(newVal) {
            console.log("newvalprovsoper", newVal);
            if (newVal && Object.keys(newVal).length > 0 ) {
                // Assign the new prop value to the local data property
                this.localOperarios = JSON.parse(JSON.stringify(newVal));
            }
        },

        operariosingular(newVal) {
            if (newVal) {
                console.log('entraopersin1');
                // Si 'operariosingular' cambia a verdadero, cargamos los datos nosotros mismos
                this.cargardatos();
            } else {
                console.log('entraopersin2');
                // Si 'operariosingular' cambia a falso, usamos los datos del padre si están disponibles
                if (this.operarios && Object.keys(this.operarios).length > 0) {
                    console.log("newvalprovsoper2", newVal);
                    this.localOperarios = JSON.parse(JSON.stringify(this.operarios));
                }
            }
        }
    }
})
</script>
<style scoped>
.marcado-check input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.p-galleria-close {

    top: 10%;
    right: 10%;

}
.p-progressbar .p-progressbar-value{
    background: #28a745 !important;
}

</style>